import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Amplify from 'aws-amplify';
import asyncComponent from '../../helpers/AsyncFunc';
import { store } from '../../redux/store';
import Notification from '../Widgets/Notification/index';
import graphql_endpoint from '../../aws-appsync-url';
import { getAppsAPI, getPayersList } from '../../helpers/helper';

const Dashboard = asyncComponent(() => import(/* webpackChunkName:"Dashboard"  */ '../dashboard'));
const Clients = asyncComponent(() => import(/* webpackChunkName:"Clients"  */ '../Page/Clients'));
const Billings = asyncComponent(() =>
  import(/* webpackChunkName:"Billings"  */ '../Page/Billings'),
);
const BillingsInsurance = asyncComponent(() =>
  import(/* webpackChunkName:"BillingsInsurance"  */ '../Page/Billings/Insurance'),
);
const BillingsNewInsurance = asyncComponent(() =>
  import(/* webpackChunkName:"BillingsNewInsurance"  */ '../Page/Billings/Insurance/NewInsurance'),
);
const BillingDocuments = asyncComponent(() =>
  import(/* webpackChunkName:"BillingDocuments"  */ '../Page/Billings/BillingDocuments'),
);
const Homework = asyncComponent(() =>
  import(/* webpackChunkName:"Homework"  */ '../Page/Homework'),
);
const HomeworkList = asyncComponent(() =>
  import(/* webpackChunkName:"HomeworkList"  */ '../Page/Homework/list'),
);
const Groups = asyncComponent(() => import(/* webpackChunkName:"Groups"  */ '../Page/Groups'));
const DbtDaily = asyncComponent(() =>
  import(/* webpackChunkName:"DbtDaily"  */ '../Page/DbtDaily'),
);
const DBTCoach = asyncComponent(() =>
  import(/* webpackChunkName:"DBTCoach"  */ '../Page/DBTCoach'),
);
const MICoach = asyncComponent(() => import(/* webpackChunkName:"MICoach"  */ '../Page/MICoach'));
const CBTCompanion = asyncComponent(() =>
  import(/* webpackChunkName:"CBTCompanion"  */ '../Page/CBTCompanion'),
);
const ACTCoach = asyncComponent(() =>
  import(/* webpackChunkName:"ACTCoach"  */ '../Page/ACTCoach'),
);
const IFSCompanion = asyncComponent(() =>
  import(/* webpackChunkName:"IFSCompanion"  */ '../Page/IFSCompanion'),
);
const DemoDesign = asyncComponent(() =>
  import(/* webpackChunkName:"TempDesign"  */ '../../components/tempDesign'),
);

const Assessments = asyncComponent(() =>
  import(/* webpackChunkName:"Assessments"  */ '../Page/Assessments'),
);
const AssessmentsConfig = asyncComponent(() =>
  import(/* webpackChunkName:"AssessmentsConfig"  */ '../Page/Assessments/assessmentConfig'),
);

const AssessmentsPopulation = asyncComponent(() =>
  import(/* webpackChunkName:"AssessmentsPopulation"  */ '../Page/Assessments/Population'),
);

const Profile = asyncComponent(() => import(/* webpackChunkName:"Profile"  */ '../Page/Profile'));

const AppointmentStatusReport = asyncComponent(() =>
  import(/* webpackChunkName:"AppointmentStatusReport"  */ '../Page/AppointmentStatusReport'),
);
const Settings = asyncComponent(() =>
  import(/* webpackChunkName:"Settings"  */ '../Page/Settings'),
);
const BillingAndService = asyncComponent(() =>
  import(/* webpackChunkName:"BillingAndService"  */ '../Page/Settings/BillingAndService'),
);
const Documents = asyncComponent(() =>
  import(/* webpackChunkName:"Documents"  */ '../Page/Settings/Documents'),
);

const SettingsNotification = asyncComponent(() =>
  import(/* webpackChunkName:"SettingsNotification"  */ '../Page/Settings/Notification'),
);

const NotesAndForms = asyncComponent(() =>
  import(/* webpackChunkName:"NotesAndForms"  */ '../Page/Settings/NotesAndForms'),
);

const ClientPortal = asyncComponent(() =>
  import(/* webpackChunkName:"ClientPortal"  */ '../Page/Settings/ClientPortal'),
);

const InsurancePayer = asyncComponent(() =>
  import(/* webpackChunkName:"InsurancePayer"  */ '../Page/Settings/InsurancePayer'),
);

const TeamMembers = asyncComponent(() =>
  import(/* webpackChunkName:"TeamMembers"  */ '../Page/Administration/Team_Members'),
);

const AccountActivity = asyncComponent(() =>
  import(/* webpackChunkName:"AccountActivity"  */ '../Page/Administration/AccountActivity'),
);

const Subscription = asyncComponent(() =>
  import(/* webpackChunkName:"Subscription"  */ '../Page/Administration/Subscription'),
);

const Insights = asyncComponent(() =>
  import(/* webpackChunkName:"Insights"  */ '../Page/Insights'),
);

const InsightsReports = asyncComponent(() =>
  import(/* webpackChunkName:"InsightsReports"  */ '../Page/Insights/reports'),
);

const Messages = asyncComponent(() =>
  import(/* webpackChunkName:"Messages"  */ '../Page/Messages'),
);

const Appointment = asyncComponent(() =>
  import(/* webpackChunkName:"Appointment"  */ '../Page/Appointment'),
);
const Coverage = asyncComponent(() =>
  import(/* webpackChunkName:"Coverage"  */ '../Page/Coverage'),
);

class AppRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasPremium: store.getState().App.get('hasPremium'),
      isOnTrial: store.getState().App.get('isOnTrial'),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.resetNotify();
    }
  }

  async componentDidMount() {
    Amplify.configure({
      API: {
        graphql_endpoint: graphql_endpoint.BTPORTAL,
      },
    });

    await getAppsAPI();
    await getPayersList();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.hasPremium !== state.hasPremium) {
      return {
        hasPremium: props.hasPremium,
      };
    }
    return null;
  }

  render() {
    const groups = store.getState().Auth.get('groups');
    const isOnlyCoordinator = groups.length === 1 && groups.includes('coordinators');
    const { url } = this.props;
    return (
      <Notification>
        {isOnlyCoordinator ? (
          <Switch>
            <Route exact path={`${url}/homework`} component={Homework} />
            <Route exact path={`${url}/homework-list`} component={HomeworkList} />
            <Route exact path={`${url}/groups`} component={Groups} />
            <Redirect to={`${url}/groups`} from='*' />
          </Switch>
        ) : (
          <Switch>
            {/* <Route
                            exact
                            path={`${url}/payments`}
                            component={asyncComponent(() => import('../Page/Payments'))}
                        /> */}
            <Route exact path={`${url}/clients`} component={Clients} />
            <Route exact path={`${url}/dashboard`} component={Dashboard} />
            <Route exact path={`${url}/billings`} component={Billings} />
            <Route exact path={`${url}/billings/insurance`} component={BillingsInsurance} />
            <Route
              exact
              path={`${url}/billings/insurance_payments/new`}
              component={BillingsNewInsurance}
            />
            <Route exact path={`${url}/homework`} component={Homework} />
            <Route exact path={`${url}/homework-list`} component={HomeworkList} />
            <Route exact path={`${url}/dbt-daily`} component={DbtDaily} />
            <Route exact path={`${url}/dbt-coach`} component={DBTCoach} />
            <Route exact path={`${url}/mi-coach`} component={MICoach} />
            <Route exact path={`${url}/cbt-companion`} component={CBTCompanion} />
            <Route exact path={`${url}/act-coach`} component={ACTCoach} />
            {/* <Route */}
            {/*  exact */}
            {/*  path={`${url}/emdr`} */}
            {/*  component={asyncComponent(() => import('../Page/emdr'))} */}
            {/* /> */}
            <Route exact path={`${url}/ifs-companion`} component={IFSCompanion} />
            <Route exact path={`${url}/demo-designs`} component={DemoDesign} />
            <Route exact path={`${url}/groups`} component={Groups} />
            <Route exact path={`${url}/assessments`} component={Assessments} />
            <Route exact path={`${url}/assessments/config`} component={AssessmentsConfig} />
            <Route exact path={`${url}/assessments/population`} component={AssessmentsPopulation} />
            <Route exact path={`${url}/profile`} component={Profile} />
            <Route exacts path={`${url}/appointment-status`} component={AppointmentStatusReport} />
            <Route exact path={`${url}/billings/documents`} component={BillingDocuments} />
            <Route exact path={`${url}/settings/practice-details`} component={Settings} />
            <Route exact path={`${url}/team_members`} component={TeamMembers} />
            <Route exact path={`${url}/account-activity`} component={AccountActivity} />
            <Route exact path={`${url}/subscription`} component={Subscription} />
            <Route
              exact
              path={`${url}/settings/billing-and-service`}
              component={BillingAndService}
            />

            <Route exact path={`${url}/settings/documents`} component={Documents} />
            <Route exact path={`${url}/settings/notifications`} component={SettingsNotification} />
            <Route exact path={`${url}/settings/notesAndForms`} component={NotesAndForms} />
            <Route exact path={`${url}/settings/client-portal`} component={ClientPortal} />
            <Route exact path={`${url}/settings/insurance-payer`} component={InsurancePayer} />
            {/* TODO: apply role based structure for reports routes also */}

            <Route exact path={`${url}/insights`} component={Insights} />
            <Route exact path={`${url}/insights/:chartType`} component={InsightsReports} />
            <Route exact path={`${url}/communication`} component={Messages} />
            <Route exact path={`${url}/appointment`} component={Appointment} />
            <Route exact path={`${url}/coverage`} component={Coverage} />

            <Redirect to={`${url}/clients`} from='*' />
          </Switch>
        )}
      </Notification>
    );
  }
}

export default withRouter(props => <AppRouter {...props} />);
